import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type {
  InitReviewContactPayload,
  ReviewContactDetailsState,
  ReviewContactScreen,
} from '../types';

const initialState: ReviewContactDetailsState = {
  currentScreen: 'review',
  isNcoaMode: false,
  userSuppliedAddress: null,
  showNcoaOptout: false,
  ncoaOptOut: false,
  useNewAddress: false,
};

const reviewContactDetailsSlice = createAppSlice({
  name: 'reviewContactDetails',
  initialState,
  reducers: {
    initReviewContact(state, action: PayloadAction<InitReviewContactPayload>) {
      const { userSuppliedAddress, showNcoaOptout } = action.payload;
      state.currentScreen = 'review';
      state.userSuppliedAddress = userSuppliedAddress;
      state.isNcoaMode = !!userSuppliedAddress;
      state.showNcoaOptout = showNcoaOptout;
      state.ncoaOptOut = userSuppliedAddress?.ncoaOptOut === true;
      state.useNewAddress = false;
    },

    setScreen(state, action: PayloadAction<ReviewContactScreen>) {
      state.currentScreen = action.payload;
    },

    setNcoaOptOut(state, action: PayloadAction<boolean>) {
      state.ncoaOptOut = action.payload;
    },

    setUseNewAddress(state, action: PayloadAction<boolean>) {
      state.useNewAddress = action.payload;
    },

    resetReviewContactState() {
      return initialState;
    },
  },
});

export const {
  initReviewContact,
  setScreen,
  setNcoaOptOut,
  setUseNewAddress,
  resetReviewContactState,
} = reviewContactDetailsSlice.actions;

export default reviewContactDetailsSlice.reducer;
